import { render } from "./TimetableOpen.vue?vue&type=template&id=3dd40c38&lang=pug"
import script from "./TimetableOpen.vue?vue&type=script&lang=js"
export * from "./TimetableOpen.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__